import React from 'react';

export default function Logo({ size = 'md', showTagline = true, className = '' }) {
  const sizes = {
    sm: { c: 28, text: 'text-xl', tag: 'text-[8px]' },
    md: { c: 40, text: 'text-3xl', tag: 'text-[10px]' },
    lg: { c: 64, text: 'text-5xl', tag: 'text-xs' },
  };
  const s = sizes[size];
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <svg width={s.c} height={s.c} viewBox="0 0 64 64" className="logo-c shrink-0">
        <defs>
          <linearGradient id="logoG" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#a78bfa" />
            <stop offset="100%" stopColor="#22d3ee" />
          </linearGradient>
        </defs>
        <path
          d="M50 16 A22 22 0 1 0 50 48"
          stroke="url(#logoG)"
          strokeWidth="6"
          fill="none"
          strokeLinecap="round"
        />
      </svg>
      <div className="flex flex-col leading-none">
        <span className={`gradient-text font-display font-bold tracking-[0.2em] ${s.text}`}>CIVIX</span>
        {showTagline && (
          <span className={`text-civix-purpleSoft/70 tracking-[0.3em] uppercase ${s.tag} mt-1`}>
            Revenue on Autopilot
          </span>
        )}
      </div>
    </div>
  );
}
